

export class CosmosHelper {
	formatCosmosDbDate(date: Date): string {
		return date.toJSON();
	}
}

export const cosmosHelper = new CosmosHelper();
